import { z } from "zod";
const assetHash = z.string().regex(/^[0-9a-f]{64}$/);
export const generationRequestedPayloadSchema = z.object({
    jobId: z.string().min(1),
    sectionIds: z.array(z.string().min(1)),
    prompt: z.string(),
});
export const generationProgressPayloadSchema = z.object({
    jobId: z.string().min(1),
    percent: z.number().int().min(0).max(100),
});
export const sectionTimingSchema = z.object({
    sectionId: z.string().min(1),
    startMs: z.number().int().min(0),
    endMs: z.number().int().min(1),
});
export const generationCompletedPayloadSchema = z.object({
    jobId: z.string().min(1),
    assetHash,
    durationMs: z.number().int().positive(),
    // Optional for backwards compatibility: events stored before the
    // generation-idempotency fix do not carry section timings, and must still
    // validate. When present, it lets a retried job recover the downstream
    // SectionAudioBound musical events without re-calling the paid provider.
    sectionTimings: z.array(sectionTimingSchema).optional(),
});
export const jobFailedPayloadSchema = z.object({
    jobId: z.string().min(1),
    kind: z.enum([
        "provider_timeout",
        "provider_rate_limit",
        "provider_error",
        "validation",
        "internal",
    ]),
    message: z.string(),
});
export const dnaAnalysisCompletedPayloadSchema = z.object({
    jobId: z.string().min(1),
    bpm: z.number().positive().max(300),
    key: z.string().min(1),
    mood: z.string().min(1),
});
export const exportCompletedPayloadSchema = z.object({
    jobId: z.string().min(1),
    assetPath: z.string().min(1),
    durationMs: z.number().int().positive(),
    bytes: z.number().int().positive(),
});
export const sectionRegenerationRequestedPayloadSchema = z.object({
    jobId: z.string().min(1),
    sectionId: z.string().min(1),
    promptDelta: z.string(),
});
export const stemsExtractedPayloadSchema = z.object({
    jobId: z.string().min(1),
    sectionId: z.string().min(1),
    stemHashes: z.record(z.string(), z.string().regex(/^[0-9a-f]{64}$/)),
});
/**
 * Idempotency key / audit trail for an envelope-extraction job. Espelha
 * `StemsExtracted`: mesmo conteúdo do musical `SectionEnvelopeExtracted` mais o
 * `jobId`. Operacional — não vai pro reducer.
 */
export const envelopeExtractedPayloadSchema = z.object({
    jobId: z.string().min(1),
    sectionId: z.string().min(1),
    sampleRateHz: z.number().int().positive().max(120),
    stems: z
        .record(z.string().min(1), z.array(z.number().min(0).max(1)))
        .refine((r) => Object.keys(r).length > 0, {
        message: "envelope must contain at least one stem",
    }),
});
/**
 * Result of a clip-render job. Espelha `ExportCompleted`, mas o clipe é gravado
 * no asset store content-addressed (`writeAsset`) e exposto por `assetHash`
 * (spec §4.3, D6) — não em `exportsRoot` por caminho. Operacional — artefato
 * derivado, não estado de áudio.
 */
export const clipRenderedPayloadSchema = z.object({
    jobId: z.string().min(1),
    assetHash,
    durationMs: z.number().int().positive(),
    bytes: z.number().int().positive(),
    width: z.number().int().positive(),
    height: z.number().int().positive(),
});
//# sourceMappingURL=jobs.js.map